import ObjectClass, * as ObjectModule from './../node_modules/ol/Object.js';

// Create a wrapper class
class Object extends ObjectClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ObjectModule) {
    if (key !== "default") {
        Object[key] = ObjectModule[key];
    }
}

export default Object;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Object.js';